import type { Transaction } from '@shared/transactions-types';
import { getEnv } from '@luna/env';
import { createQueryString } from '@luna/router';

import { getTransactionsFeaturesParams } from '../getTransactionsFeaturesParams';

export function getTransactionUpdateUrl({ id }: Transaction): string {
    const { georgeApiUrl } = getEnv();
    const featuresParams = getTransactionsFeaturesParams();
    const queryParams = createQueryString(featuresParams);

    return `${georgeApiUrl}my/transactions/${id}${queryParams}`;
}
